// client/src/pages/AccountSettings.js
import React, { useState, useContext, useEffect } from 'react';
import { Box, Typography, TextField, Button, Alert, Stack } from '@mui/material';
import { AuthContext } from '../context/AuthContext';
import { API_BASE_URL } from '../utils/media';

const AccountSettings = () => {
  const { user, userProfile, token } = useContext(AuthContext);
  const [formData, setFormData] = useState({ email: '', company: '', phone: '', address: '' });
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (userProfile) {
      setFormData({
        email: userProfile.email || '',
        company: userProfile.company || '',
        phone: userProfile.phone || '',
        address: userProfile.address || '',
      });
    } else if (user) {
      setFormData((prev) => ({ ...prev, email: user.email || '' }));
    }
  }, [user, userProfile]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      const response = await fetch(`${API_BASE_URL}/api/profile`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error('Failed to update profile.');
      setIsError(false);
      setMessage('Profile updated successfully!');
    } catch (err) {
      setIsError(true);
      setMessage(err.message);
    }
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>Account Settings</Typography>
      {userProfile?.client_number && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Your client number: <strong>{userProfile.client_number}</strong>
        </Typography>
      )}
      <Stack component="form" onSubmit={handleSubmit} spacing={2} sx={{ maxWidth: 480, mt: 2 }}>
        {message && <Alert severity={isError ? 'error' : 'success'}>{message}</Alert>}
        <TextField label="Email Address" type="email" name="email" value={formData.email} onChange={handleChange} required fullWidth />
        <TextField label={user?.role === 'admin' ? 'Company Name (used on invoices)' : 'Company (Optional)'} name="company" value={formData.company} onChange={handleChange} fullWidth />
        <TextField label="Phone (Optional)" name="phone" value={formData.phone} onChange={handleChange} fullWidth />
        <TextField label="Address (Optional)" name="address" value={formData.address} onChange={handleChange} fullWidth multiline minRows={2} />
        <Button type="submit" variant="contained" sx={{ alignSelf: 'flex-start' }}>Save Changes</Button>
      </Stack>
    </Box>
  );
};

export default AccountSettings;
